'use client';

import { signIn } from 'next-auth/react';
import { Button, Flex } from '@radix-ui/themes';

export default function LogInForm() {
  return (
    <Flex direction="column" gap="2">
      <Button type="submit" size="3" variant="solid" onClick={() => signIn('google')} className="bg-rose-500">
        Sign in with Google
      </Button>
      <Button type="submit" size="3" variant="solid" onClick={() => signIn('apple')} className="bg-black text-white">
        Sign in with Apple
      </Button>
    </Flex>
  );
}
